import { autoserialize } from 'cerialize';

export class TncDriverTraining {
  @autoserialize
  driverId: number;

  @autoserialize
  attendedAdaTraining: boolean;

  @autoserialize
  cprTestPassed: boolean;
}
